import React from 'react';
import { Box, Typography } from '@mui/material';
import DecimalInput from '../UiComponents/DecimalInput';

const MainMeterConsumption = ({ validIndexTypes, values, onChange }) => {
  const handleChange = (indexType, value) => {
    onChange(prev => ({
      ...prev,
      [indexType]: value
    }));
  };

  return (
    <Box mt={3}>
      <Typography variant="h6" gutterBottom>Ana Sayaç Tüketimleri</Typography>
      {validIndexTypes.map(type => (
        <DecimalInput
          key={type.indexType}
          label={`${type.indexName} (${type.indexType})`}
          value={values[type.indexType] || ''}
          onChange={(val) => handleChange(type.indexType, val)}
          unit={type.unit}
          maxDecimalDigits={3}
          decimalSeparator=","
        />
      ))}
    </Box>
  );
};

export default MainMeterConsumption;
